export function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6" data-testid={testid}>
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-foreground">{title}</h1>
        {subtitle && <p className="text-muted-foreground text-sm mt-1 max-w-2xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

const TONE = {
  NEW: "bg-ochre/15 text-ochre", PENDING: "bg-ochre/15 text-ochre", OPEN: "bg-ochre/15 text-ochre",
  DUE: "bg-ochre/15 text-ochre", REVIEW: "bg-ochre/15 text-ochre", APPLIED: "bg-ochre/15 text-ochre",
  IN_PROGRESS: "bg-brand/12 text-brand", INTERVIEW: "bg-brand/12 text-brand", SCHEDULED: "bg-brand/12 text-brand",
  ACTIVE: "bg-success/15 text-success", COMPLETED: "bg-success/15 text-success", DONE: "bg-success/15 text-success",
  ACCEPTED: "bg-success/15 text-success", HIRED: "bg-success/15 text-success", APPROVED: "bg-success/15 text-success", CONVERTED: "bg-success/15 text-success",
  OVERDUE: "bg-danger/12 text-danger", DECLINED: "bg-danger/12 text-danger", REJECTED: "bg-danger/12 text-danger",
  CANCELLED: "bg-danger/12 text-danger", CLOSED: "bg-muted text-muted-foreground", INACTIVE: "bg-muted text-muted-foreground",
  ARCHIVED: "bg-muted text-muted-foreground", MAINTENANCE: "bg-terracotta/15 text-terracotta",
  HIGH: "bg-danger/12 text-danger", MEDIUM: "bg-ochre/15 text-ochre", LOW: "bg-muted text-muted-foreground",
};

export function StatusBadge({ value }) {
  if (value === undefined || value === null || value === "") return <span className="text-muted-foreground">—</span>;
  const key = String(value).toUpperCase();
  const cls = TONE[key] || "bg-secondary text-secondary-foreground";
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${cls}`}>
      {String(value).replace(/_/g, " ")}
    </span>
  );
}

export function fmtDate(v) {
  if (!v) return "—";
  try {
    const d = new Date(v);
    if (isNaN(d.getTime())) return String(v);
    return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
  } catch { return String(v); }
}
